import 'firebase/database'
import { functions } from '@/firebase'
// import router from '../router'
import { removedIntegrationAction } from '@/utils/logsHelpers'

export default {
  namespaced: true,
  state: {
  },
  getters: {
    expired (state, getters, rootState, rootGetters) {
      const expired = {}
      ;['mailchimp', 'klaviyo'].forEach(service => {
        expired[service] = !!(
          rootGetters['auth/user'] &&
          rootGetters['auth/user'].integrations &&
          rootGetters['auth/user'].integrations[service] &&
          rootGetters['auth/user'].integrations[service].expired
        )
      })
      return expired
    }
  },
  mutations: {
  },
  actions: {
    async getInstallURL (context, { service }) {
      const result = await functions.httpsCallable('integrations-getInstallURL')({ service })
      if (result) return result.data
      else return null
    },
    async connect ({ commit }, { service, code }) {
      const result = await functions.httpsCallable('integrations-connect')({ service, code })

      commit('pushAnalyticsEvent', {
        action: 'Integration Complete',
        properties: {
          service
        }
      }, { root: true })
      if (result) return result.data
      else return null
    },
    async disconnect ({ rootState }, { service }) {
      removedIntegrationAction(rootState.auth.user, { service, message: `Disonnected ${service} integration` })
      return await functions.httpsCallable('integrations-disconnect')({ service })
    },
    async getAudiences (context, { service }) {
      const result = await functions.httpsCallable('integrations-getAudiences')({ service })
      if (result) return result.data
      else return null
    },
    async setAudience (context, { service, audienceId }) {
      const result = await functions.httpsCallable('integrations-setAudience')({ service, audienceId })
      if (result) return result.data
      else return null
    },
    async getHubspotOwners (context, { userId }) {
      const result = await functions.httpsCallable('integrations-getHubspotOwners')({ userId })
      if (result) return result
      else return null
    },
    async getHubspotLists (context, { userId }) {
      const result = await functions.httpsCallable('integrations-getHubspotLists')({ userId })
      if (result) return result
      else return null
    },
    async createHubspotTag (context, { userId }) {
      const result = await functions.httpsCallable('integrations-createHubspotTag')({ userId })
      if (result) return result
      else return null
    }
  }
}
